import { TextField, Button, Box } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { PermissionRequestBody } from "../../../../api/mosaic/interface";
import ModalWrapper, { modalCancelButtonSx, modalSubmitButtonSx } from "../../../shared/ModalWrapper";

interface IProps {
  openModal: boolean;
  handleClose: () => void;
  handleOnChange: (key: string, value: string) => void;
  handleUpdatePermission: () => void;
  handleOnCreatePermission: () => void;
  isNewForm: boolean;
  isLoading: boolean;
  formData: PermissionRequestBody;
  setFormData: Dispatch<SetStateAction<PermissionRequestBody>>;
}

const PermissionModal: React.FC<IProps> = ({
  openModal,
  handleClose,
  handleOnChange,
  handleUpdatePermission,
  handleOnCreatePermission,
  isNewForm,
  formData,
  isLoading,
}) => {
  return (
    <ModalWrapper
      open={openModal}
      onClose={handleClose}
      title={isNewForm ? "Create Permission" : "Update Permission"}
      actions={
        <>
          <Button variant="outlined" onClick={handleClose} sx={modalCancelButtonSx}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={isNewForm ? handleOnCreatePermission : handleUpdatePermission}
            disabled={isLoading || !formData.name?.trim()}
            sx={modalSubmitButtonSx}
          >
            {isNewForm ? "Create" : "Update"}
          </Button>
        </>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <TextField
          label="Permission Name *"
          fullWidth
          value={formData.name}
          onChange={(e) => handleOnChange("name", e.target.value)}
          inputProps={{ maxLength: 100 }}
        />
      </Box>
    </ModalWrapper>
  );
};

export default PermissionModal;
